import { Sparkles } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  return (
    <section
      data-testid="marquee"
      aria-label="Our specialities"
      className="py-10 md:py-12 border-y border-gold/15 bg-cocoa-900 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} aria-hidden={half === 1} className="flex items-center shrink-0">
            {MARQUEE_ITEMS.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span
                  className={`px-7 font-display text-3xl md:text-4xl whitespace-nowrap ${
                    i % 2 === 0 ? "text-stroke-gold" : "italic font-light text-gold/80"
                  }`}
                >
                  {item}
                </span>
                <Sparkles className="w-5 h-5 text-gold/50 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
